import { get, post, patch, del } from './apiHelper';

const emailCustomizationService = {
    // Obtener todas las personalizaciones de una marca
    getCustomizations: async (marcaId) => {
        try {
            return await get(`mail/customization/${marcaId}`);
        } catch (error) {
            // No loguear error 404, es normal cuando no hay personalizaciones
            if (error.status !== 404) {
                console.error('Error obteniendo personalizaciones:', error);
            }
            throw error;
        }
    },

    // Obtener personalización de un template específico
    getCustomization: async (marcaId, templateName) => {
        try {
            return await get(`mail/customization/${marcaId}/${templateName}`);
        } catch (error) {
            console.error(`Error obteniendo personalización de ${templateName}:`, error);
            throw error;
        }
    },

    // Crear personalización inicial para una marca
    createCustomization: async (marcaId, templates) => {
        try {
            return await post(`mail/customization/${marcaId}`, { templates });
        } catch (error) {
            console.error('Error creando personalización:', error);
            throw error;
        }
    },

    // Actualizar personalización de un template
    updateCustomization: async (marcaId, templateName, customization) => {
        try {
            return await patch(`mail/customization/${marcaId}/${templateName}`, customization);
        } catch (error) {
            console.error(`Error actualizando personalización de ${templateName}:`, error);
            throw error;
        }
    },

    // Eliminar personalización (reset a valores por defecto)
    deleteCustomization: async (marcaId, templateName) => {
        try {
            return await del(`mail/customization/${marcaId}/${templateName}`);
        } catch (error) {
            console.error(`Error eliminando personalización de ${templateName}:`, error);
            throw error;
        }
    },

    // Resetear todas las personalizaciones
    resetAllCustomizations: async (marcaId) => {
        try {
            return await post(`mail/customization/${marcaId}/reset`);
        } catch (error) {
            console.error('Error reseteando personalizaciones:', error);
            throw error;
        }
    },

    // Previsualizar email con personalización
    previewEmail: async (previewData) => {
        try {
            return await post('mail/customization/preview', previewData);
        } catch (error) {
            console.error('Error previsualizando email:', error);
            throw error;
        }
    }
};

export default emailCustomizationService;





